import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgNotificationsSelectedNavIconSecondary(props) {
  return jsx("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M19.284 16.149H.698a.697.697 0 1 0 0 1.395H7.73c0 .065-.018.13-.018.195A2.263 2.263 0 0 0 9.972 20a2.263 2.263 0 0 0 2.26-2.26c0-.066-.009-.13-.018-.196h7.051a.703.703 0 0 0 .698-.698.687.687 0 0 0-.68-.697ZM18.307 8.419c0-.028.01-.066.01-.093C18.316 3.74 14.576 0 9.99 0 5.433 0 1.72 3.674 1.665 8.214c-.01.037-.01.074-.01.112v6.632h16.661v-6.54h-.009Z",
    fill: "currentColor"
  }));
}

export { SvgNotificationsSelectedNavIconSecondary as default };
